module.exports = __webpack_public_path__ + "img/2.ac008569.svg";